module.exports = __webpack_public_path__ + "static/media/pantrylogo.02bf8cbf.png";